import React, { useEffect, useRef, useState } from 'react'
import BlogResponse from '../utility/BloggerResp.json'
import SectionHeader from '../components/SectionHeader'
import { apiRequestURL } from '../utility/BlogFunctions'

import useOnScreen from '../utility/useIntersection'

import TAT from '../images/tat_2_resize.png'

export default function BlogPage() {

    // State
    let [titles, setTitles] = useState("")
    let [urls, setURLS] = useState("")
    let [tags, setTags] = useState("")

    const blogPageRef = useRef()
    const blogIsVisible = useOnScreen(blogPageRef, "0px")

    // Function to fetch the Blpgs 
    async function getBlogData(){
        const URL = apiRequestURL;
        const response = await fetch(URL);
        const BloggerResponse = await response.json();
        const blogs = BloggerResponse["items"]
        let titlesArray = blogs.map((item)=>{
            return (item["title"].trim())
        })
        let urls= blogs.map((item)=>{
            return (item["url"])
        })

        let tags = blogs.map((item)=>{
            return (item["labels"])
        })
        setTitles((old)=>titlesArray)
        setURLS((old)=>urls)
        setTags((old)=>tags)

    }

    // Using the function 
    useEffect(()=>{
        getBlogData()
    }, [])



    return (
        <div className={`blog-page container fade-in-section ${blogIsVisible?'is-visible':''}`} id="blog-page" ref={blogPageRef}>
            <SectionHeader 
            sectionHeading = 'IV - Blog Updates'
            sectionNumber =  '4'
            alignment = 'section-number-align-start' 
            headerAlignment = 'align-start'
            />

            <div className="blog-visual">
                
                <a href="https://tippingathought.blogspot.com/">
                <img src={TAT} alt="tipping a thought blog" />
                </a>
            </div>


                
                <ol className="recent-blogs">
                {titles?titles.slice(0, 5).map((item, index)=>{
                    return(
                        
                            

                                <li className="blog-item light-color">
                                    <a href={urls[index]}>
                                        <h4 className="light-color upper-case">{item}</h4>
                                    </a>
                                    <div className="grid-content">
                                        <ul className="tags">
                                            {
                                                tags?tags[index].map((item)=>{
                                                    return (
                                                        <li className="low-contrast-color">{item}</li>
                                                    )
                                                })
                                            :null}
                                        </ul>
                                        <div className="button-div"><a href={urls[index]} className="button accent-color">View Post</a></div>
                                    </div>

                                </li>
                        
                    )
                }):null}
                </ol>


            {/* <div className="blog-button">
                <a href="https://tippingathought.blogspot.com/" className="button">View Blog</a>
                
            </div> */}

        </div>
    )
}
